import React from 'react';
import { useEffect, useState } from 'react';
import { sizes } from '../constants/devices';

export function useIsWhichSize() {
  const [isMobile, setIsMobile] = useState<boolean>(
    window.innerWidth <= sizes.mobile
  );
  const [isSmallerScreen, setIsSmallerScreen] = useState<boolean>(
    window.innerWidth <= sizes.smallerScreen
  );
  const [width, setWidth] = useState<number>(window.innerWidth);

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth <= sizes.mobile);
      setIsSmallerScreen(window.innerWidth <= sizes.smallerScreen);
      setWidth(window.innerWidth);
    }

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [window.innerWidth]);

  return { isMobile, isSmallerScreen, width };
}
